import React from 'react';
import PropTypes from 'prop-types';
import { InfoBoxButton, SimpleInfoBox } from '@dmm/lib-react-ui-components';
import './index.css';

const ConversationalCta = ({ id, enabled, variant, children, ...props }) => {
  if (!enabled) {
    return <></>;
  }

  const Component = getComponentByVariant(variant);

  return (
    <div id={id} className="conversational-cta">
      <Component {...props}>
        {children}
      </Component>
    </div>
  );
};

ConversationalCta.propTypes = {
  id: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf(['button', 'simple']).isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.oneOf(['location', 'propulsion', 'measurements', 'description']),
  classNames: PropTypes.shape({
    icon: PropTypes.bool,
    contrast: PropTypes.bool,
    shadow: PropTypes.bool,
    untruncate: PropTypes.bool
  }),
  link: PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.string,
    onClick: PropTypes.func
  }),
  children: PropTypes.node
};

const getComponentByVariant = (variant) => {
  switch (variant) {
  case 'button':
    return InfoBoxButton;
  case 'simple':
    return SimpleInfoBox;
  }
};

export default ConversationalCta;
